import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { HistoryLookupService } from '../historyLookup.service';
import { RestrictService, Roles } from '../../../Common/Permissions/restrict.service';
import { UpgradeNavigationServiceHandler } from '../../../Common/Routing/upgrade-navigation-handler.service';

@Component({
    selector: 'history-lookup-page',
    templateUrl: './historyLookupPage.component.html',
    styleUrls: ['./historyLookupPage.component.scss'],
    standalone: false,
})
export class HistoryLookupPageComponent implements OnInit, OnDestroy {
    constructor(
        public readonly _historyLookupService: HistoryLookupService,
        private readonly _restrictService: RestrictService,
        private readonly _routerService: UpgradeNavigationServiceHandler,
    ) {}

    private readonly searchTriggerSub = new Subject<Core.HistoryLookupSearchModel>();
    readonly searchTrigger$ = this.searchTriggerSub.asObservable();
    isInitialized: boolean = false;

    tableOptions: Core.IndexedHistoryTableModel[] = [];
    tableSelections: Core.NameIdPair[] = [];
    currentSelectedTableId: number = 0;
    currentIndexedHistoryTable: Core.IndexedHistoryTableModel | null = null;
    currentTableColumnSets: Core.IndexedHistoryColumnSetModel[] = [];
    selectedColumnSet: Core.IndexedHistoryColumnSetModel | null = null;
    searchModel: Core.HistoryLookupSearchModel = {
        indexedHistoryTableId: 0,
        indexedHistoryColumnId: 0,
        columnIdValues: [],
    };

    async ngOnInit(): Promise<void> {
        if (
            !(
                this._restrictService.isInRole(Roles.ADMINOPERATIONSVIEW) ||
                this._restrictService.isInRole(Roles.ADMINOPERATIONSEDIT)
            )
        ) {
            this.navigateToUnauthorized();
            return;
        }

        this.tableOptions = await this._historyLookupService.getTableOptions();
        this.tableSelections = this.tableOptions
            .map((to) => ({
                id: to.indexedHistoryTableId,
                name: to.historyTableName,
            }))
            .sort((a, b) => a.name.localeCompare(b.name));

        this.isInitialized = true;
    }

    ngOnDestroy(): void {
        if (this.searchTriggerSub) {
            this.searchTriggerSub.complete();
            this.searchTriggerSub.unsubscribe();
        }
    }

    selectTable(indexedHistoryTableId: number): void {
        this.currentSelectedTableId = indexedHistoryTableId;
        this.searchModel.indexedHistoryTableId = this.currentSelectedTableId;
        this.currentIndexedHistoryTable =
            this.tableOptions.find((t) => t.indexedHistoryTableId === indexedHistoryTableId) || null;
        this.currentTableColumnSets = this.currentIndexedHistoryTable?.columnSets || [];

        //console.log('currentSelectedTableId', this.currentSelectedTableId);
        //console.log('currentTableColumnSets', this.currentTableColumnSets);

        // Select the first column set by default when a table is selected
        const selectedColumnSetId =
            this.currentTableColumnSets.length > 0 ? this.currentTableColumnSets[0].setIndexedHistoryColumnId : 0;

        this.selectColumnSet(selectedColumnSetId);
    }

    selectColumnSet(selectedColumnSetId: number): void {
        this.searchModel.indexedHistoryColumnId = selectedColumnSetId;
        this.selectedColumnSet =
            this.currentTableColumnSets.find((cs) => cs.setIndexedHistoryColumnId === selectedColumnSetId) || null;

        // Reset columnIdValues when column set changes
        this.searchModel.columnIdValues = [];
        if (this.selectedColumnSet) {
            for (let i = 0; i < this.selectedColumnSet.setColumns.length; i++) {
                this.searchModel.columnIdValues.push(0);
            }
        }

        //console.log('currentSelectedColumnId', this.searchModel.indexedHistoryColumnId);
        //console.log('selectedColumnSet', this.selectedColumnSet);
        console.log('searchModel', this.searchModel);
    }

    tableSelectionChanged(optionName: any): void {
        const selection = optionName ? this.tableSelections.find((x) => x.name === optionName) : null;
        this.currentSelectedTableId = selection?.id ?? 0;
        this.selectTable(this.currentSelectedTableId);
    }

    columnSelectionChanged(optionName: any): void {
        const selection = optionName ? this.currentTableColumnSets.find((x) => x.setName === optionName) : null;
        const selectedColumnSetId = selection?.setIndexedHistoryColumnId ?? 0;
        this.selectColumnSet(selectedColumnSetId);
    }

    readyToSearch(): boolean {
        if (
            this.searchModel.indexedHistoryTableId <= 0 ||
            !this.currentTableColumnSets ||
            this.currentTableColumnSets.length === 0 ||
            this.searchModel.indexedHistoryColumnId <= 0 ||
            !this.selectedColumnSet ||
            !this.searchModel.columnIdValues
        ) {
            return false;
        }

        return this.searchModel.columnIdValues.every((value) => value > 0);
    }

    doSearch(): void {
        console.log('searchModel', this.searchModel);
        this.searchTriggerSub.next(this.searchModel);
    }

    navigateToUnauthorized(): void {
        this._routerService.go('unauthorizedAccess', {});
    }
}
